import { MintStatus } from '@arpeggi/shared'
import React from 'react'
import { useMintStatus } from '../../../../queries/mintStatuses'
import BlankState from './BlankState'
import { PreviewBar, PreviewContainer, PreviewContainerWrapper } from './MediaPreview'

interface Props {
  jobId: string
}

export const MintStatusFeedbackMap = {
  [MintStatus.Error]: 'Something went wrong.',
  [MintStatus.Queued]: '(Step 1/8) Your mint is queued...',
  [MintStatus.MintingSong]: '(Step 2/8) Minting song token...',
  [MintStatus.RenderingAndUploadingAudio]: '(Step 3/8) Rendering and uploading audio...',
  [MintStatus.RegisteringStemTokens]: '(Step 4/8) Registering stems to ARP ...',
  [MintStatus.RegisteringSongToArp]: '(Step 5/8) Registering song to ARP...',
  [MintStatus.WaitingForSongRegistrationConfirmation]:
    '(Step 6/8) Waiting for ARP song confirmation...',
  [MintStatus.Complete]: '(Step 7/8) Compiling final metadata...'
}

const MintInProgressPreview: React.FC<Props> = ({ jobId }) => {
  const { data } = useMintStatus({ jobId })

  return (
    <PreviewBar>
      <PreviewContainerWrapper>
        <PreviewContainer>
          <BlankState title={MintStatusFeedbackMap[data?.mintStatus]} />
        </PreviewContainer>
      </PreviewContainerWrapper>
    </PreviewBar>
  )
}

export default MintInProgressPreview
